import { getAppConfig } from "@/config/env"

// SDK 默认 的WebRTC 连接配置
export const _DEFAULT_CONN_CONFIG = {
  // 信令服务器地址
  signalingServer: getAppConfig().signalingUrl,
  // Relay 服务器配置
  relay: [
    {
      addr: "r.ked.ksyun.com",
      user: "kdesk1",
      pwd: "kdesk1_Ab",
    },
  ],
}

export const OldAgentKeyCodeMap = new Map([
  ["KeyA", 0],
  ["KeyB", 1],
  ["KeyC", 2],
  ["KeyD", 3],
  ["KeyE", 4],
  ["KeyF", 5],
  ["KeyG", 6],
  ["KeyH", 7],
  ["KeyI", 8],
  ["KeyJ", 9],
  ["KeyK", 10],
  ["KeyL", 11],
  ["KeyM", 12],
  ["KeyN", 13],
  ["KeyO", 14],
  ["KeyP", 15],
  ["KeyQ", 16],
  ["KeyR", 17],
  ["KeyS", 18],
  ["KeyT", 19],
  ["KeyU", 20],
  ["KeyV", 21],
  ["KeyW", 22],
  ["KeyX", 23],
  ["KeyY", 24],
  ["KeyZ", 25],
  ["Digit0", 26],
  ["Digit1", 27],
  ["Digit2", 28],
  ["Digit3", 29],
  ["Digit4", 30],
  ["Digit5", 31],
  ["Digit6", 32],
  ["Digit7", 33],
  ["Digit8", 34],
  ["Digit9", 35],
  ["Backquote", 36],
  ["AsciiTiled", 37],
  ["Exclam", 38],
  ["At", 39],
  ["NUMBER_SIGN", 40],
  ["Dollar", 41],
  ["Percent", 42],
  ["AsciiCircum", 43],
  ["Ampersand", 44],
  ["Asterisk", 45],
  ["ParentLeft", 46],
  ["ParentRight", 47],
  ["Minus", 48],
  ["UnderScore", 49],
  ["Plus", 50],
  ["Equal", 51],
  ["BraceLeft", 52],
  ["BraceRight", 53],
  ["BracketLeft", 54],
  ["BracketRight", 55],
  ["Bar", 56],
  ["Backslash", 57],
  ["Semicolon", 58],
  ["Colon", 59],
  ["Quote", 60],
  ["QuoteDBL", 61],
  ["Less", 62],
  ["Comma", 63],
  ["Greater", 64],
  ["Period", 65],
  ["Question", 66],
  ["Slash", 67],
  ["Divide", 68],
  ["Multiply", 69],
  ["Add", 70],
  ["Subtract", 71],
  ["Deciml", 72],
  ["F1", 73],
  ["F2", 74],
  ["F3", 75],
  ["F4", 76],
  ["F5", 77],
  ["F6", 78],
  ["F7", 79],
  ["F8", 80],
  ["F9", 81],
  ["F10", 82],
  ["F11", 83],
  ["F12", 84],
  ["Enter", 153],
  ["Cancel", 86],
  ["Backspace", 87],
  ["Tab", 88],
  ["Clear", 89],
  ["Return", 90],
  ["Alt", 91],
  ["AltLeft", 92],
  ["AltRight", 93],
  ["Shift", 94],
  ["ShiftLeft", 95],
  ["ShiftRight", 96],
  ["Control", 97],
  ["ControlLeft", 98],
  ["ControlRight", 99],
  ["Win", 100],
  ["WinLeft", 101],
  ["WinRight", 102],
  ["Menu", 103],
  ["MenuLeft", 104],
  ["MenuRight", 105],
  ["Pause", 106],
  ["CapsLock", 107],
  ["Kana", 108],
  ["Hangul", 109],
  ["Junja", 110],
  ["Final", 111],
  ["Hanja", 112],
  ["Kanji", 113],
  ["Escape", 114],
  ["Convert", 115],
  ["Space", 116],
  ["Prior", 117],
  ["Next", 118],
  ["End", 119],
  ["Home", 120],
  ["ArrowLeft", 121],
  ["ArrowUp", 122],
  ["ArrowRight", 123],
  ["ArrowDown", 124],
  ["Select", 125],
  ["Print", 126],
  ["Execute", 127],
  ["Snapshot", 128],
  ["Insert", 129],
  ["Delete", 130],
  ["Help", 131],
  ["Sleep", 132],
  ["Separator", 133],
  ["Mute", 144],
  ["Shortcut", 145],
  ["Option", 146],
  ["PageDown", 147],
  ["PageUp", 148],
  ["ScrollLock", 149],
  ["NumLock", 150],
  ["VolumeDown", 151],
  ["VolumeUp", 152],
  ["Command", 154],
  ["Apps", 155],
  ["Super", 156],
  ["SuperLeft", 157],
  ["SuperRight", 158],
  ["Hyper", 159],
  ["HyperLeft", 160],
  ["HyperRight", 161],
  ["Meta", 162],
  ["MetaLeft", 163],
  ["MetaRight", 164],
  ["CtrlAltDel", 165],
  ["LockScreen", 166],
  ["NumpadDivide", 68],
  ["NumpadMultiply", 69],
  ["NumpadAdd", 70],
  ["NumpadSubtract", 71],
  ["NumpadEnter", 153],
  // Delete
  ["NumpadDecimal", 130],
  // Insert
  ["Numpad0", 129],
  // End
  ["Numpad1", 119],
  // ArrowDown
  ["Numpad2", 124],
  // PageDown
  ["Numpad3", 147],
  // ArrowLeft
  ["Numpad4", 121],
  // ArrowRight
  ["Numpad6", 123],
  // Home
  ["Numpad7", 120],
  // ArrowUp
  ["Numpad8", 122],
  // PageUp
  ["Numpad9", 148],
])

export const NewAgentKeyCodeMap = new Map([
  ["KeyA", 0x04], // 4
  ["KeyB", 0x05], // 5
  ["KeyC", 0x06], // 6
  ["KeyD", 0x07], // 7
  ["KeyE", 0x08], // 8
  ["KeyF", 0x09], // 9
  ["KeyG", 0x0a], // 10
  ["KeyH", 0x0b], // 11
  ["KeyI", 0x0c], // 12
  ["KeyJ", 0x0d], // 13
  ["KeyK", 0x0e], // 14
  ["KeyL", 0x0f], // 15
  ["KeyM", 0x10], // 16
  ["KeyN", 0x11], // 17
  ["KeyO", 0x12], // 18
  ["KeyP", 0x13], // 19
  ["KeyQ", 0x14], // 20
  ["KeyR", 0x15], // 21
  ["KeyS", 0x16], // 22
  ["KeyT", 0x17], // 23
  ["KeyU", 0x18], // 24
  ["KeyV", 0x19], // 25
  ["KeyW", 0x1a], // 26
  ["KeyX", 0x1b], // 27
  ["KeyY", 0x1c], // 28
  ["KeyZ", 0x1d], // 29
  ["Digit1", 0x1e], // 30
  ["Digit2", 0x1f], // 31
  ["Digit3", 0x20], // 32
  ["Digit4", 0x21], // 33
  ["Digit5", 0x22], // 34
  ["Digit6", 0x23], // 35
  ["Digit7", 0x24], // 36
  ["Digit8", 0x25], // 37
  ["Digit9", 0x26], // 38
  ["Digit0", 0x27], // 39
  ["Enter", 0x28], // 40
  ["Escape", 0x29], // 41
  ["Backspace", 0x2a], // 42
  ["Tab", 0x2b], // 43
  ["Space", 0x2c], // 44
  ["Minus", 0x2d], // 45
  ["Equal", 0x2e], // 46
  ["BracketLeft", 0x2f], // 47
  ["BracketRight", 0x30], // 48
  ["Backslash", 0x31], // 49
  ["Semicolon", 0x33], // 51
  ["Quote", 0x34], // 52
  ["Backquote", 0x35], // 53
  ["Comma", 0x36], // 54
  ["Period", 0x37], // 55
  ["Slash", 0x38], // 56
  // ["CapsLock", 0x39],
  ["F1", 0x3a],
  ["F2", 0x3b],
  ["F3", 0x3c],
  ["F4", 0x3d],
  ["F5", 0x3e],
  ["F6", 0x3f],
  ["F7", 0x40],
  ["F8", 0x41],
  ["F9", 0x42],
  ["F10", 0x43],
  ["F11", 0x44],
  ["F12", 0x45],
  ["PrintScreen", 0x46], // 70
  ["F13", 0x46], // 70
  ["ScrollLock", 0x47], // 71
  ["Pause", 0x48], // 72
  ["Insert", 0x49], // 73
  ["Home", 0x4a], // 74
  ["PageUp", 0x4b], // 75
  ["Delete", 0x4c], // 76
  ["End", 0x4d], // 77
  ["PageDown", 0x4e], // 78
  ["ArrowRight", 0x4f], // 79
  ["ArrowLeft", 0x50], // 80
  ["ArrowDown", 0x51], // 81
  ["ArrowUp", 0x52], // 82
  // ["NumLock", 0x53],
  ["Control", 0xe0], // 224
  ["ControlLeft", 0xe0], // 224
  ["ControlRight", 0xe4], // 228
  ["Shift", 0xe1], // 225
  ["ShiftLeft", 0xe1], // 225
  ["ShiftRight", 0xe5], // 229
  ["Alt", 0xe2], // 226
  ["AltLeft", 0xe2], // 226
  ["AltRight", 0xe6], // 230
  ["Meta", 0xe3], // 227
  ["MetaLeft", 0xe3], // 227
  ["MetaRight", 0xe7], // 231
  ["Menu", 0x76], // 76
  ["NumpadDivide", 0x54], // 84
  ["NumpadMultiply", 0x55], // 85
  ["NumpadSubtract", 0x56], // 86
  ["NumpadAdd", 0x57], // 87
  ["NumpadEnter", 0x58], // 88
  // Delete
  ["NumpadDecimal", 0x4c],
  // Insert
  ["Numpad0", 0x49],
  // End
  ["Numpad1", 0x4d],
  // ArrowDown
  ["Numpad2", 0x51],
  // PageDown
  ["Numpad3", 0x4e],
  // ArrowLeft
  ["Numpad4", 0x50],
  ["Numpad5", 0x22],
  // ArrowRight
  ["Numpad6", 0x4f],
  // Home
  ["Numpad7", 0x4a],
  // ArrowUp
  ["Numpad8", 0x52],
  // PageUp
  ["Numpad9", 0x4b],
])

// 如果是 Window 锁定的时候，数字键的 platformkey 对应如下，如果不一样就是非锁定
export const OldAgentNumLockKeyCodeMap = new Map([
  ["Numpad0", 134],
  ["Numpad1", 135],
  ["Numpad2", 136],
  ["Numpad3", 137],
  ["Numpad4", 138],
  ["Numpad5", 139],
  ["Numpad6", 140],
  ["Numpad7", 141],
  ["Numpad8", 142],
  ["Numpad9", 143],
  ["NumpadDecimal", 72],
])

export const NewAgentNumLockKeyCodeMap = new Map([
  ["Numpad1", 0x1e],
  ["Numpad2", 0x1f],
  ["Numpad3", 0x20],
  ["Numpad4", 0x21],
  ["Numpad6", 0x23],
  ["Numpad7", 0x24],
  ["Numpad8", 0x25],
  ["Numpad9", 0x26],
  ["Numpad0", 0x27],
  ["NumpadDecimal", 0x37],
])

// 远端消息的 code，每种消息都有一个唯一的 code
export const _MSG_CODE_MOUSE = 2001
export const _MSG_CODE_KEYBOARD = 2002
export const _MSG_CODE_CALL = 1504
export const _MSG_CODE_CALL_ACK = 1505
export const _MSG_CODE_END_CALL = 1506
export const _MSG_CODE_SET_CUSTOM_DATA = 1512
export const _MSG_CODE_SET_VIDEO_RESOLUTION = 1517
export const _MSG_CODE_SET_VIDEO_DPI = 1605
export const _MSG_CODE_GET_VIDEO_DPI = 1606
export const _MSG_CODE_BLOCK_APP_INSTALL = 1609
export const _MSG_CODE_SET_WALLPAPER = 1610
export const _MSG_CODE_GET_PEER_DEVICE_INFO = 1501
export const _MSG_CODE_GET_PEER_DEVICE_INFO_ACK = 1502
export const _MSG_CODE_SHOW_REMOTE_CURSOR = 1511
export const _MSG_CODE_SEND_JSON_DATA = 1515
export const _CUSTOM_MSG_ID_FIRST_FRAME_RENDER = 5
export const _CUSTOM_MSG_ID_MIC_STATE_CHANGE = 12
export const _CUSTOM_MSG_ID_CAMERA_STATE_CHANGE = 13
export const _CUSTOM_MSG_ID_CLIENT_CONFIG = 21
export const _MSG_CODE_ENABLE_AUDIO = 1550
export const _MSG_CODE_SET_CURSOR_ID = 2014
export const _MSG_CODE_SET_CURSOR_DATA = 2015
export const _MSG_CODE_SET_CURSOR_POS = 2016
export const _MSG_CODE_CLEAR_CURSOR_CACHE = 2017
export const _MSG_CODE_BEGIN_FILE_TRANSFER = 2031
export const _MSG_CODE_BEGIN_FILE_TRANSFER_ACK = 2032
export const _MSG_CODE_FILE_TRANSFER_DATA = 2033
export const _MSG_CODE_FILE_TRANSFER_DATA_ACK = 2034
export const _MSG_CODE_END_FILE_TRANSFER = 2035
export const _MSG_CODE_END_FILE_TRANSFER_ACK = 2036
export const _MSG_CODE_FILE_TRANSFER_CONTROL = 2037
export const _MSG_CODE_FILE_TRANSFER_CONTROL_ACK = 2038
export const _MSG_CODE_REPLY_RESULT = 50000
